var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolLength = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(2 2.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.749,
  height: 7.779,
  x: -0.874,
  y: 7.611,
  strokeWidth: 1.5,
  rx: 1,
  transform: "rotate(-45.001 11.5 11.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.117 12.384 2.015 1.984M7.686 9.815l2.5 2.5M10.123 7.379l1.75 1.75M12.558 4.942l2.5 2.5M15.113 2.388l2.015 1.986M2.564 14.938l2.5 2.5"
})))));
export { SvgToolLength as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-length.svg";